import styled from "styled-components";
import { Color } from "ts/enums/color";

export const StyledUserEditorBlock = styled.div`
  background-color: ${Color.white};
  margin: 0 auto 16px auto;
  border-radius: 5px;
`;
